// extracted by mini-css-extract-plugin
export var endRoundContainer = "EndRound-module--endRoundContainer--1Ecav";
export var title = "EndRound-module--title--17R4o";
export var movieFoundButtons = "EndRound-module--movieFoundButtons--2LexB";
export var movieActionSelected = "EndRound-module--movieActionSelected--1tbdV";
export var movieActionNotSelected = "EndRound-module--movieActionNotSelected--1GZpf";
export var proceedButton = "EndRound-module--proceedButton--2jokD";